// @ts-check
import React, { forwardRef } from "react"
import ClientProjectChip from "../molecules/ClientProjectChip.molecule"
import DropdownCustomFilterSearch from "../molecules/DropdownCustomFilterSearch.molecule"
import { formatDropdownProjects } from "../../utils/project.utils"
import ErrorMessageForm from "../atoms/ErrorMessageForm.atom"
import { hasAnyErrors } from "../../utils/validations.utils"
import DropdownInput from "../molecules/DropdownInput.molecule"

/** @type {import("./DropdownProjectFilter.compound.types.d.ts").DropdownProjectFilter} */
const DropdownProjectFilter = forwardRef(
  (
    {
      label = null,
      placeholder = "Elige un proyecto",
      name = "projectTagName",
      optionValue = "projectID",
      optionLabel = "projectName",
      withoutErrorMessage = true,
      error = [],
      badgeTemplate = true,
      inputProps,
      ...props
    },
    ref
  ) => {
    let options = props.options
    if (!options) return
    options = formatDropdownProjects(options)

    return (
      <div className="field m-0">
        <DropdownInput
          ref={ref}
          filter
          label={label}
          name={name}
          placeholder={placeholder}
          optionValue={optionValue}
          optionLabel={optionLabel}
          panelClassName="max-w-23rem"
          scrollHeight="417px"
          itemTemplate={(option) => {
            const { clientTagName, projectTagName } = options.find(
              (o) => o[optionValue] === option[optionValue]
            )
            return (
              <div className="flex gap-2 align-items-center project-item ">
                <div
                  className=".selected-highlight"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    zIndex: 0,
                    left: 0,
                    top: 0,
                  }}
                ></div>
                <ClientProjectChip
                  clientCode={clientTagName}
                  projectCode={projectTagName}
                />
                <p className="text-overflow-ellipsis overflow-hidden whitespace-nowrap">
                  {option?.projectName}
                </p>
              </div>
            )
          }}
          valueTemplate={(option) => {
            const valueLabel = option?.projectTagName || placeholder
            return badgeTemplate && valueLabel !== placeholder ?
                <div className="flex gap-2 align-items-center overflow-hidden">
                  <ClientProjectChip
                    clientCode={option?.clientTagName}
                    projectCode={option?.projectTagName}
                    labelClassname="my-1 text-sm"
                  />
                </div>
              : valueLabel
          }}
          emptyMessage={"No hay proyectos"}
          // @ts-ignore
          filterTemplate={(
            /** @type {import("../molecules/DropdownCustomFilterSearch.molecule.types").ParentDropdownFilterProps} */
            props
          ) => (
            <DropdownCustomFilterSearch
              props={props}
              // @ts-ignore
              inputProps={
                inputProps ?
                  typeof inputProps === "function" ?
                    inputProps(props)
                  : inputProps
                : undefined
              }
            />
          )}
          filterBy="clientTagName,projectTagName,projectName"
          {...props}
        />
        {hasAnyErrors(error) && !withoutErrorMessage ?
          <ErrorMessageForm errorMessage={error[0]?.errorMessage} />
        : null}
      </div>
    )
  }
)

export default DropdownProjectFilter
